import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Clears the unread badge when the notifications dropdown is opened. Attached to
// the bell button; fires on click. read_all is idempotent, so re-firing on a
// toggle-close is harmless — we still skip the request when nothing is unread.
export default class extends Controller {
  static values = { url: String };
  declare readonly urlValue: string;

  markRead = async () => {
    const badge = document.getElementById("notifications-badge");
    if (!badge || badge.children.length === 0) return;

    const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Accept": "text/vnd.turbo-stream.html", "X-CSRF-Token": token },
    });
    if (response.ok) Turbo.renderStreamMessage(await response.text());
  };
}
